module.exports = __webpack_public_path__ + "media/images/hamber-f30c19e14d3ecbe3acddc71cf0df224c.svg";